import { Route, Routes, useNavigate } from "react-router-dom";
import { LoginCallback, Security } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { oktaAuth } from "./authConfig";
import ErrorComponent from "./components/ErrorComponent";
import Login from "./components/Login";
import RequiredAuth from "./RequiredAuth";

const MyRoutes = () => {
    const history = useNavigate();

    const originalUri = async (_oktaAuth, originalUri) => {
        history(toRelativeUrl(originalUri || "/", window.location.origin));
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={originalUri}>
            <Routes>
                <Route
                    path="/login/callback"
                    element={<LoginCallback errorComponent={ErrorComponent} />}
                />
                <Route path="/" exact={true} element={<Login />} />
                <Route path="/:section" exact={true} element={<Login />} />
                <Route path="/team/:id" exact={true} element={<Login />} />
                <Route path="/logout/callback" element={<Login />} />
            </Routes>
        </Security>
    );
};
export default MyRoutes;
